module.exports = __webpack_public_path__ + "static/media/Pensando en ti.f38a20cc.jpg";